(function ($, Drupal, once) {

  Drupal.behaviors.pagulasabiNav = {
    attach: function (context, settings) {
      once('pagulasabiNavJS', '.dropdown-language', context).forEach(function () {
        // $(this).children('.dropdown-toggle').on('click', clickHandler);
        $(document).click(function (e) {
          if (!$(e.target).is('.dropdown-language .collapse')) {
            $('.dropdown-language .collapse').collapse('hide');
          }
        });
      });
    }
  }

})(jQuery, Drupal, once);
